import React, { useState, Fragment } from 'react';
// import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import axios from 'axios';
// import { compose } from 'recompose';
import {
	// Row, Col,
	Form, Input, Button
} from 'antd';
import { ErrorAlert } from '../ErrorAlert';
// import { SubmitButton } from '../SubmitButton';
// import { SubmitButtonHelper } from '../SubmitButtonHelper';

// import { useInputValue } from '../../hooks/useInputValue';
// import { validateLoginForm } from '../../utils/validations';
// import { LOGIN } from '../../gql/mutations/auth';

const LoginForm = ({ activateAuth }) => {

	// const [disabled, setDisabled] = useState(false);
	const [error, setError] = useState(null);
	const [form] = Form.useForm();

	const [isLoading, setLoading] = useState(false);
	
	// const [ authUser ] = useMutation(LOGIN);

	const onSubmit = (values) => {
		// setDisabled(true);
		setError(null);
		setLoading(true);

		const loginUrl = `${process.env.REACT_APP_BACKEND}/auth/login`;
		axios.post(loginUrl, Object.assign({}, values, { fromReq: 'web' }))
		.then(resp => {
			console.log('response', resp);
			setLoading(false);
			const { data: { success, token, message } } = resp;
			if (success) {
				activateAuth(token);
			} else {
				setError(message);
				// setDisabled(false);
			}
		})
		.catch(err => {
			setLoading(false);
		});
	};

	const onSubmitFailed = ({ errorFields }) => {
		form.scrollToField(errorFields[0].name);
	};

	return (
		<Fragment>
			<Form
				onFinish={onSubmit} 
				onFinishFailed={onSubmitFailed}
				layout="vertical"
			>
				<Form.Item name="username" rules={[{ required: true, message: 'Username is required' }]}>
					<Input placeholder='Enter Username' />
				</Form.Item>
				<Form.Item name="password" rules={[{ required: true, message: 'Password is required' }]}>
					<Input.Password placeholder='Enter Password' />
				</Form.Item>
				<br/>
				{/* <div class="clearfix">
					<div class="checkbox c-checkbox float-left mt-0"><label><input type="checkbox" value="" name="remember"/><span class="fa fa-check"></span> Remember Me</label></div>
					<div class="float-right"><a class="text-muted" href="recover.html">Forgot your password?</a></div>
				</div> */}
				{
					isLoading &&
					<Button 
						className="btn btn-block btn-primary mt-3" 
						type='primary' 
						loading
					>
						Login
					</Button>
				}
				{
					!isLoading &&
					<button 
						className="btn btn-block btn-primary mt-3" 
						type='submit'
					>
						Login
					</button>
				}
			</Form>
			{
				error && <ErrorAlert errorMessage={error} />
			}
		</Fragment>
	);
};

LoginForm.propTypes = {
	activateAuth: PropTypes.func.isRequired,
};

export default LoginForm;